/*
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import baseURL from './components/pages/user/config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NetworkErrorPage from './components/Reusable/NetworkErrorPage';

const RootComponent = () => {
  const [paypalClientId, setPaypalClientId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchClientId = async () => {
      try {
        const response = await fetch(`${baseURL}/paypal/config`);
        if (!response.ok) throw new Error('Failed to fetch PayPal configuration');
        const data = await response.json();
        setPaypalClientId(data.paypalClientId);
      } catch (err) {
        console.error('Error fetching PayPal Client ID:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchClientId();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          gap: 2
        }}
      >
        <CircularProgress sx={{ color: 'green' }} />
        <span style={{ fontSize: '1rem', fontWeight: 500, fontFamily: "'Outfit', sans-serif" }}>Loading...</span>
      </Box>
    );
  }

  if (error || !paypalClientId) {
    return <NetworkErrorPage onRetry={() => window.location.reload()} />;
  }

  return (
    <React.StrictMode>
      <PayPalScriptProvider options={{ clientId: paypalClientId }}>
        <App />
      </PayPalScriptProvider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <RootComponent />
      </>
);

reportWebVitals();
*/


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Cache immutable assets + offline shell for faster repeat visits on slow
// networks (production only; see public/sw.js).
serviceWorkerRegistration.register();

reportWebVitals();
